
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12px","height":"12px","viewBox":"0 0 12 12","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M11.8066667,2.695 C12.0666667,2.435 12.0666667,2.00166667 11.8066667,1.755 L10.2466667,0.195 C10,-0.065 9.56666667,-0.065 9.30666667,0.195 L8.08,1.415 L10.58,3.915 M0,9.50166667 L0,12.0016667 L2.5,12.0016667 L9.87333333,4.62166667 L7.37333333,2.12166667 L0,9.50166667 Z"}})])
          )
        }
      }
    